import { render } from "./admin-users.svg?vue&type=template&id=08be2ac6"
const script = {}
script.render = render

export default script